let stripe
let elements
if (window.Stripe) {
  stripe = window.Stripe(window.PI_STRIPE_KEY)
  elements = stripe.elements()
}

export { elements }
export default stripe
